import About from "../components/javascripts/About"
import Navigation from "../components/javascripts/Navigation"

export const AboutPage = () => {
    return (
        <>
            <Navigation/>
            <About/>
        </>
    )
}